import { getAxiosInstance } from '../../react/utils/networkUtil';
import { AppSuccess } from '../models/AppSuccess';
import { AC_Project_Role } from '../services/access_control/AC_Project';
import { AC_Organization_Role } from '../services/access_control/AC_Organization';
import { Invitation_Base, InvitationType } from '../models/Invitation';

// Send invitation
export type Invitation_Send_Request = {
  identifier: string; // it could be phone number or email
  projectId?: number;
  organizationId?: number;
  role?: AC_Project_Role | AC_Organization_Role;
  type?: InvitationType;
};
export type Invitation_Send_Response = AppSuccess<Invitation_Base>;
export const remote_sendInvitation = async (request: Invitation_Send_Request): Promise<AppSuccess<Invitation_Base>> => {
  return (await getAxiosInstance().post('/api/invitation-ext', request)).data;
};
// End send invitation

export type Invitation_GetMyPendingInvitations_Response = AppSuccess<Invitation_Base[]>;
export const remote_getMyPendingInvitations = async (): Promise<Invitation_GetMyPendingInvitations_Response> => {
  return (await getAxiosInstance().get('/api/invitation-ext/my-pending-invitations')).data;
};
// End get my pending invitations

// Get invitation detail
export type Invitation_GetInvitationDetail_Response = Invitation_Base;
/**
 * Get invitation by numeric ID
 * @deprecated Use remote_getInvitationByDocumentId instead for better performance with documentId
 */
export const remote_getInvitationDetail = async (id: number): Promise<Invitation_GetInvitationDetail_Response> => {
  return (await getAxiosInstance().get(`/api/invitation-ext/get-one/${id}`)).data;
};

export const remote_getInvitationByDocumentId = async (documentId: string): Promise<Invitation_GetInvitationDetail_Response> => {
  return (await getAxiosInstance().get(`/api/invitation-ext/document-id/${documentId}`)).data;
};
// End get invitation detail

// Accept invitation
export const remote_acceptInvitation = async (id: number): Promise<AppSuccess<Invitation_Base>> => {
  return (await getAxiosInstance().put(`/api/invitation-ext/${id}/accept`)).data;
};
// End accept invitation

// Decline invitation
export const remote_declineInvitation = async (id: number): Promise<AppSuccess<Invitation_Base>> => {
  return (await getAxiosInstance().put(`/api/invitation-ext/${id}/decline`)).data;
};
// End decline invitation

// Get project pending invitations
export type Invitation_GetProjectPendingInvitations_Request = {
  projectId: number;
};
export const remote_getProjectPendingInvitations = async (
  request: Invitation_GetProjectPendingInvitations_Request,
): Promise<Array<Invitation_Base>> => {
  return (
    await getAxiosInstance().get('/api/invitation-ext/project-pending-invitations', {
      params: request,
    })
  ).data;
};
// End get project pending invitations

// Get organization pending invitations
export type Invitation_GetOrganizationPendingInvitations_Request = {
  organizationId: number;
};
export const remote_getOrganizationPendingInvitations = async (
  request: Invitation_GetOrganizationPendingInvitations_Request,
): Promise<Array<Invitation_Base>> => {
  return (
    await getAxiosInstance().get('/api/invitation-ext/organization-pending-invitations', {
      params: request,
    })
  ).data;
};
// End get organization pending invitations

// Delete invitation
export const remote_deleteInvitation = async (id: number): Promise<AppSuccess<Invitation_Base>> => {
  return (await getAxiosInstance().delete(`/api/invitation-ext/${id}`)).data;
};
// End delete invitation

// Get invitation list (paginated)
import { PaginationQuery, PaginationResult } from '../models/AppPagination';

export type Invitation_GetList_RequestQuery = PaginationQuery;
export type Invitation_GetList_Response = PaginationResult<Invitation_Base>;
export const remote_Invitation_getList = async (request: Invitation_GetList_RequestQuery): Promise<Invitation_GetList_Response> => {
  return (await getAxiosInstance().get('/api/invitation-ext', { params: request })).data;
};
// End get invitation list

export const InvitationAPIs = {
  remote_sendInvitation,
  remote_getMyPendingInvitations,
  remote_getInvitationDetail,
  remote_getInvitationByDocumentId,
  remote_acceptInvitation,
  remote_declineInvitation,
  remote_getProjectPendingInvitations,
  remote_getOrganizationPendingInvitations,
  remote_deleteInvitation,
  remote_Invitation_getList,
};
